import Image from "@components/core/Image";
import Link from "@components/core/Link";
import { usePrice } from "@hooks/use-prices";

function GiftCardOption({
  amount = 70,
}) {
  const price = usePrice();

  return (
    <Link className="gift-card-option-container" href={`/buy_gift_cards/informations?amount=${amount}`}>
      <div className="icon-container">
        <Image src="logoSmallWhite" className="w-100" alt="logo"/>
      </div>
      <h4 className="mb-0 text-white text-end price">
        {price(amount * 100, { withoutCents: true, withoutSpace: true })}
      </h4>
    </Link>
  );
}

export default GiftCardOption;
